import React from 'react';
import { CardDesign } from '../../../../../../../components/CardDesign';
import RelatedPersons from './RelatedPersons';
import { ReactComponent as RelatedPersonsIcon } from '../../../../../../../resource/RelatedPersonsIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { selectShutdownsFilter } from '../../../model/selectors';
import { applyShutdownFilter } from '../../../model/actions';
import {
  SET_CREATE_WORKER_ID_SHUTDOWN_FILTER,
  SET_INITIATOR_ID_SHUTDOWN_FILTER,
  SET_RESPOSIBLE_ID_SHUTDOWN_FILTER,
} from '../../../model/types';
import { getDocOptionsWorkersSelect } from '../../../../../shared/utils/getShutdownsOptions';
import { useShutdownInitiators } from '../../../../../shared/api/queries/shutdownInitiators';
import { useShutdownResponsible } from '../../../../../shared/api/queries/shutdownResponsible';
import { useShutdownWorkers } from '../../../../../shared/api/queries/shutdownWorkers';

const RelatedPersonsFilterCard = () => {
  const { createWorkerId, initiatorIds, executorIds, cityId, companyId } =
    useSelector(selectShutdownsFilter);

  const dispatch = useDispatch();

  const { data: initiatorsOptions, isFetching: isInitiatorsFetching } =
    useShutdownInitiators(cityId, {
      staleTime: Infinity,
      enabled: Boolean(cityId),
    });
  const { data: responsibleOptions, isFetching: isResponsibleFetching } =
    useShutdownResponsible([companyId], {
      staleTime: Infinity,
    });
  const { data: workersOptions, isFetching: isWorkersFetching } =
    useShutdownWorkers({
      staleTime: Infinity,
    });

  const makeChangeHandler = (actionType) => (value) => {
    dispatch(applyShutdownFilter(actionType)(value));
  };

  const createWorkerConfig = {
    data: getDocOptionsWorkersSelect(workersOptions),
    value: createWorkerId,
    onChange: makeChangeHandler(SET_CREATE_WORKER_ID_SHUTDOWN_FILTER),
    isLoading: isWorkersFetching,
    placeholder: 'Создатель',
  };

  const initiatorIdsConfig = {
    data: getDocOptionsWorkersSelect(initiatorsOptions),
    value: initiatorIds,
    onChange: makeChangeHandler(SET_INITIATOR_ID_SHUTDOWN_FILTER),
    isLoading: isInitiatorsFetching,
    disabled: !Boolean(cityId),
    disabledText: 'Укажите город для выбора инициаторов',
    placeholder: 'Инициаторы',
    isMultiple: true,
  };

  const responsibleIdConfig = {
    data: getDocOptionsWorkersSelect(responsibleOptions),
    value: executorIds,
    onChange: makeChangeHandler(SET_RESPOSIBLE_ID_SHUTDOWN_FILTER),
    isLoading: isResponsibleFetching,
    disabled: !Boolean(companyId),
    disabledText: 'Укажите УК для выбора ответственных',
    placeholder: 'Ответственные',
    isMultiple: true,
  };

  return (
    <CardDesign style={{ backgroundColor: 'white' }}>
      <CardDesign.Header
        heading="Связанные лица"
        icon={<RelatedPersonsIcon />}
      />

      <CardDesign.Body>
        <RelatedPersons
          configs={[
            createWorkerConfig,
            initiatorIdsConfig,
            responsibleIdConfig,
          ]}
        />
      </CardDesign.Body>
    </CardDesign>
  );
};

export default RelatedPersonsFilterCard;
